// extracted by mini-css-extract-plugin
module.exports = {"hasAppBlock":"TenantsTable_hasAppBlock__3T0vU"};